import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class SSHService {
  async getData(data) {
    return (await fetchApi.post(`/ssh`, data)).data;
  }

  async delete(data) {
    return (await fetchApi.post(`/ssh/delete`, data)).data;
  }

  async download(Workspace_id, data) {
    const apiURL = (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "") + "/api/v1";
    const url = apiURL + `/ssh/${Workspace_id}/download?` + new URLSearchParams(data).toString();

    window.open(url, "_blank");
  }

  async upload(formData, ProcessQueue_id, customHeaders) {
    return (await fetchApi.postFormData(`/ssh/upload?ProcessQueue_id=${ProcessQueue_id}`, formData, customHeaders))
      .data;
  }

  async createFolder(data) {
    return (await fetchApi.post(`/ssh/createfolder`, data)).data;
  }
}
